'use es6';

import { List, Map as ImmutableMap } from 'immutable';
import { MarkEncoding } from 'reporting-visualizations/visualizations/xy/xyRecords';
export const applyXYHideMarkers = (visualization, report) => {
  const hideMarkers = report.getIn(['displayParams', 'hideMarkers']);
  if (!hideMarkers) {
    return visualization;
  }
  return visualization.update('layers', (layers = List()) => layers.map(layer => layer.update('mark', (mark = MarkEncoding({})) => mark.update('marker', (marker = ImmutableMap()) => marker.set('enabled', false)))));
};